<div class="toggle-button-wrapper">
    <span class="toggle-button">
        <input [checked]="checked" (change)="changed($event)" id="{{childId}}" type="checkbox" />
        <label for="{{childId}}">
            <i class="fas {{faIconClass}}"></i>
            <ng-content>
            </ng-content>
        </label>
    </span>
</div>